import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_DOCUMENT_MAP_DATA: createActionType(FULL_NAMESPACE, "GET_DOCUMENT_MAP_DATA"),
    GET_DOCUMENT_MAP_DATA_COMPLETED: createActionType(FULL_NAMESPACE, "GET_DOCUMENT_MAP_DATA_COMPLETED"),
    SAVE_DOCUMENT_MAP_DATA: createActionType(FULL_NAMESPACE, "SAVE_DOCUMENT_MAP_DATA"),
    SAVE_DOCUMENT_MAP_DATA_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_DOCUMENT_MAP_DATA_COMPLETED"),
    SET_MAP_DATA_FOR_DOCUMENT: createActionType(FULL_NAMESPACE, "SET_MAP_DATA_FOR_DOCUMENT"),
    CLEAR_DATA: createActionType(FULL_NAMESPACE, "CLEAR_DATA"),
    ADD_GEOMETRY: createActionType(FULL_NAMESPACE, "ADD_GEOMETRY"),
    UPDATE_MAP_DATA: createActionType(FULL_NAMESPACE, "UPDATE_MAP_DATA"),
    SET_DETAILED_PANEL_OPEN: createActionType(FULL_NAMESPACE, "SET_DETAILED_PANEL_OPEN"),
    SET_DELETED: createActionType(FULL_NAMESPACE, "SET_DELETED"),
    SET_MAP_OPTIONS: createActionType(FULL_NAMESPACE, "SET_MAP_OPTIONS")
};
